import { Form, Col, Row } from "react-bootstrap";
import { CustomSelect, InsuranceOptions } from "../../../../../../_helpers/Helpers";

export function PersonnelContractInfoForm({
  handleChange,
  setFieldValue,
  values
 }) {
  const salary = values.salary != null ? values.salary : "";
  const formalSalary = values.formalSalary != null ? values.formalSalary : "";

  return (
    <div className="row">
      <div className="col-6">  
        <Form.Group as={Row}>
          <Form.Label column sm={4}>
            Dönem
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="number" 
              min={0}
              value={values.term}
              id="contract.term" 
              placeholder="Dönem"
              onChange={e => {
                handleChange(e)
                handleChange("contract.term2")(e);
              }}
            />
          </Col>
          <Col sm={4}>
            <Form.Control value={values.term + 1} id="contract.term2" readOnly />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="contract.insuranceStartDate">
          <Form.Label column sm={4}>
            Sigorta Başlangıç Tarihi
          </Form.Label>
          <Col sm={8}>
            <Form.Control type="date" value={values.insuranceStartDate} placeholder="Sigorta Başlangıç Tarihi" onChange={handleChange} />
          </Col>
        </Form.Group>
                        
        <Form.Group as={Row} controlId="contract.formalContractStartDate">
          <Form.Label column sm={4}>
            Resmi Sözleşme Baslangıç Tarihi
          </Form.Label>
          <Col sm={8}>
            <Form.Control type="date" value={values.formalContractStartDate} placeholder="Resmi Sözleşme Baslangıç Tarihi" onChange={handleChange} />
          </Col>
        </Form.Group>
                        
        <Form.Group as={Row} controlId="contract.contractStartDate">
          <Form.Label column sm={4}>
            Sözleşme Baslangıç Tarihi
          </Form.Label>
          <Col sm={8}>
            <Form.Control type="date" value={values.contractStartDate} placeholder="Sözleşme Baslangıç Tarihi" onChange={handleChange} />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="contract.formalSalary">
          <Form.Label column sm={4}>
            Resmi Maaşı
          </Form.Label>
          <Col sm={8}>
          <Form.Control type="number" min={0} value={formalSalary} placeholder="Resmi Maaşı" onChange={handleChange} />
          </Col>
        </Form.Group>
      </div>          

      <div className="col-6">
        <Form.Group as={Row} controlId="contract.insurance">
          <Form.Label column sm={4}>
            Sigorta
          </Form.Label>
          <Col sm={8}>
            <CustomSelect 
              options={InsuranceOptions}
              value={values.insurance}
              onChange={option => setFieldValue("contract.insurance", option.value)}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="contract.insuranceEndDate">
          <Form.Label column sm={4}>
            Sigorta Bitiş Tarihi
          </Form.Label>
          <Col sm={8}>
            <Form.Control type="date" value={values.insuranceEndDate} placeholder="Sigorta Bitiş Tarihi" onChange={handleChange} />
          </Col>
        </Form.Group>
                        
        <Form.Group as={Row} controlId="contract.formalContractEndDate">
          <Form.Label column sm={4}>
            Resmi Sözleşme Bitiş Tarihi
          </Form.Label>
          <Col sm={8}>
            <Form.Control type="date" value={values.formalContractEndDate} placeholder="Resmi Sözleşme Bitiş Tarihi" onChange={handleChange} />
          </Col>
        </Form.Group>
                        
        <Form.Group as={Row} controlId="contract.contractEndDate">
          <Form.Label column sm={4}>
            Sözleşme Bitiş Tarihi
          </Form.Label>
          <Col sm={8}>
            <Form.Control type="date" value={values.contractEndDate} placeholder="Sözleşme Bitiş Tarihi" onChange={handleChange} />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="contract.salary">
          <Form.Label column sm={4}>
            Maaşı
          </Form.Label>
          <Col sm={8}>
            <Form.Control type="number" min={0} value={salary} placeholder="Maaşı" onChange={handleChange} />
          </Col>
        </Form.Group>
      </div>
    </div>
  );
}